module.exports = __webpack_public_path__ + "static/media/video_thumbnail.71034d46.png";